import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withSize } from 'react-sizeme';
import { useIntl } from 'react-intl';
import classNames from 'classnames';

import MessagePropType from '../definitions/MessagePropType';
import Checkmark from '../graphics/Checkmark';
import messageToString from '../functions/messageToString';


function ChecklistBlock({ features, title, checklistTextSizeSuffix, size, className, ...otherProps }) {
    const intl = useIntl();

    const checklistTextSizeClassName = `rh-text-${checklistTextSizeSuffix}`;
    const useASingleColumn = size?.width <= ONE_COLUMN_BREAKPOINT;
    const featureStrings = features.map(msg => messageToString(msg, intl));

    return (
        <div
            className={className}
            {...otherProps}
        >
            <If condition={title}>
                {/* TODO investigate if this should be h3 or prop-based and update callers: CCDEP-3145 */}
                <h4 className="rh-title-2xs rh-mt-0 rh-mb-0_5">
                    {messageToString(title, intl)}
                </h4>
            </If>

            <ul className={`feature-list ${checklistTextSizeClassName} rh-pl-0 rh-mt-0_5 rh-list-style`}>
                <For
                    each="feature"
                    of={featureStrings}
                >
                    <li
                        className={classNames('feature-item rh-mr-1 rh-mb-0_5 rh-align-items-center',
                            { 'rh-width-100p': useASingleColumn })}
                        key={feature}
                    >
                        <Checkmark className="check-mark rh-icon-2xs rh-mr-0_5" />
                        {feature}
                    </li>
                </For>
            </ul>
        </div>
    );
}

ChecklistBlock.propTypes = {
    features: PropTypes.oneOfType([
        PropTypes.arrayOf(MessagePropType),
        PropTypes.objectOf(MessagePropType),
    ]).isRequired,
    title: MessagePropType,
    checklistTextSizeSuffix: PropTypes.oneOf([ '2xs', 'xs', 's', 'm' ]),
    size: PropTypes.shape({
        width: PropTypes.number,
    }).isRequired,
    className: PropTypes.string,
};

ChecklistBlock.defaultProps = {
    title: undefined,
    checklistTextSizeSuffix: 's',
    className: undefined,
};

const ONE_COLUMN_BREAKPOINT = 320;


export default withSize()(styled(ChecklistBlock)`
    > .feature-list {
        list-style-type: none;

        > .feature-item {
            display: inline-flex;

            .check-mark {
                flex-shrink: 0;
            }
        }
    }
`);
